__turbopack_context__.v({
  "J": "style-module-scss-module__1yOsJa__J",
  "U": "style-module-scss-module__1yOsJa__U",
  "activeLetter": "style-module-scss-module__1yOsJa__activeLetter",
  "bold": "style-module-scss-module__1yOsJa__bold",
  "component": "style-module-scss-module__1yOsJa__component",
  "content-container": "style-module-scss-module__1yOsJa__content-container",
  "down-arrow": "style-module-scss-module__1yOsJa__down-arrow",
  "down-arrow-container": "style-module-scss-module__1yOsJa__down-arrow-container",
  "hero-quote-container": "style-module-scss-module__1yOsJa__hero-quote-container",
  "jumpInfinite": "style-module-scss-module__1yOsJa__jumpInfinite",
  "slideDownUp": "style-module-scss-module__1yOsJa__slideDownUp",
  "video-container": "style-module-scss-module__1yOsJa__video-container",
  "visible": "style-module-scss-module__1yOsJa__visible",
});
